import { defineStore } from 'pinia';

export const usePeopleStore = defineStore('people', {
  state: () => ({
    all_available_people: [],
    person: {}, // Used to hold who we are editing or creating.
    taxonomy: [],
    selected_taxonomy: null,
    default_person: {
      name: null,
      artwork: null,
      artwork_uuid: null,
      role: 'Host',
      group: 'Cast',
      is_default: 0,
    },
  }),
  actions: {
    async getAllPeople(withRelations = true) {
      try {
        const data = {};
        if (withRelations) {
          data.with_items = true;
          data.with_feeds = true;
        }
        this.all_available_people = (await axios.get('/api/v1/people', {
          params: data,
        })).data.data;
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
    async getTaxonomy() {
      try {
        const response = await axios.get('/api/v1/people/taxonomy');
        this.taxonomy = response.data.data;
        if (this.person.uuid) {
          // Set the selected taxomony based on who we are editing
          this.setupPersonEdit();
        } else {
          // Set the default taxomony value
          this.setupPersonCreate();
        }
      } catch (e) {
        window.handleAxiosError(e);
      }
    },
    setupPersonEdit(person = null) {
      if (person) {
        this.person = { ...person };
      }
      this.selected_taxonomy = _.find(this.taxonomy, item => item.group === this.person.group && item.role === this.person.role);
    },
    setPerson(person) {
      this.person = { ...person };
    },
    setupPersonCreate() {
      this.person = { ...this.default_person };
      this.selected_taxonomy = _.find(this.taxonomy, item => item.group === 'Cast' && item.role === 'Host');
    },
  },
});
